import { useEffect, useState } from 'react';
import { Button, Input, Modal } from 'antd';

import styles from './index.module.scss';

const { TextArea } = Input;

export interface ReasonModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  subtitle?: string;
  placeholder?: string;
  actionButtonText: string;
  loading?: boolean;
  onSubmit: (reason: string) => void;
}

export default function ReasonModal({
  open,
  setOpen,
  title,
  subtitle,
  placeholder,
  actionButtonText,
  loading,
  onSubmit,
}: ReasonModalProps): JSX.Element {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) {
      setReason('');
    }
  }, [open]);

  const handleSubmit = () => {
    if (reason.trim()) {
      onSubmit(reason.trim());
    }
  };

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      title={title}
      centered
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          danger
          disabled={!reason.trim()}
          loading={loading}
          onClick={handleSubmit}
        >
          {actionButtonText}
        </Button>,
      ]}
    >
      {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      <TextArea
        rows={4}
        maxLength={255}
        placeholder={placeholder}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />
    </Modal>
  );
}
